import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { Fund } from '../types';
import { EditableFund } from '../funds/schemas/fundSchema';

export const useCreateFund = () => {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    isPending: isLoading,
    isError,
  } = useMutation<{ data: Fund }, Error, EditableFund>({
    mutationFn: fund => api.post<Fund>('funds', fund),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['funds'] });
    },
  });

  const createFund = async (fund: EditableFund) => {
    return mutateAsync(fund);
  };

  return {
    createFund,
    isLoading,
    isError,
  };
};
